import ProductPageApp from './ProductPageApp/ProductPageApp';
import { withControllerContext } from './ControllerContext';

export default withControllerContext(ProductPageApp);
